import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { InvoiceService } from '@/lib/services/invoice'
import { useToast } from '@/hooks/use-toast'
import { Invoice, Paginator } from '@/types'
import { LoadingSpinner } from '@/components/layout/loading-spinner'
import InvoiceList from '@/components/invoices/InvoiceList'
import { useLocation } from 'react-router-dom'

export default function MyInvoicesPage() {
  const { t } = useTranslation(['invoices', 'common'])
  const location = useLocation()

  const { toast } = useToast()
  const [invoices, setInvoices] = useState<Paginator<Invoice>>()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchInvoices = async () => {
      const searchParams = new URLSearchParams(location.search)
      const page = Number(searchParams.get('page') ?? 1)
      const user_id = searchParams.get('user_id')
        ? parseInt(searchParams.get('user_id') as string)
        : null

      let params: any = { page }

      if (user_id) {
        params.userId = user_id
      }

      try {
        setLoading(true)
        const response = await InvoiceService.getInvoices(params)
        setInvoices(response)
      } catch (error) {
        toast({
          title: t('error_loading_invoices'),
          description: t('please_try_again_later'),
          variant: 'destructive',
        })
      } finally {
        setLoading(false)
      }
    }

    fetchInvoices()
  }, [location])

  const handleDownload = async (invoice: Invoice) => {
    try {
      window.open(invoice.storagePath, '_blank')
    } catch (error) {
      toast({
        title: t('error_downloading_invoice'),
        description: t('please_try_again_later'),
        variant: 'destructive',
      })
    }
  }

  if (loading || !invoices) {
    return <LoadingSpinner />
  }

  return (
    <div className="container mx-auto px-6 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">{t('Invoices')}</h1>
      </div>

      <InvoiceList
        invoices={invoices}
        onDownload={handleDownload}
        setInvoices={setInvoices}
      />
    </div>
  )
}
